export default "__VITE_ASSET__a645b319__"